import React, { useEffect, useState } from "react";
import { getGallery } from "../Service/Api";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';
const Gallery = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
 const monthNames = ["Jan","Feb","Mar","Apr","May" ,"Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getGallery();
        setData(galleryData);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const emptyData = [
    { title: "Gallery Title"}, 
    { title: "Gallery Title"},
    { title: "Gallery Title"},
    { title: "Gallery Title"},
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2, 
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow:2, 
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1, 
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, 
        }
      }
    ]
  };
 
   const filteredData = data.filter(item => item.category === "PhotoGallery");  

  return (
    <>
       
        <Slider {...settings}>
             {filteredData.length >= 4 &&
          filteredData.map((item, index) => {
            const galdate = new Date(item.date);
            const day = galdate.getDate();
            const month = monthNames[galdate.getMonth()];
            
          return( 
             <div className="item" key={index}>
                <div className="galleryimg homegallery">
                    <div className="galleryimgbox">
                      <LazyLoad><img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                    alt={item.title}
                    className="img-fluid"
                  /> </LazyLoad>
                    <div className="gallerydesc">
                      <Link to="/" className="gallery_button">{day} {month}</Link>
                      <h6> {item.title}</h6>
                    </div>
                  </div> 
              </div>
           </div>
          )})}
          {filteredData.length < 4 &&
            filteredData.length > 0 &&
            filteredData.map((item, index) =>
              item.attachments.map((img) => {
                const galdate = new Date(item.date);
                const day = galdate.getDate();
                const month = monthNames[galdate.getMonth()];
                
              return (
                <div className="item" key={index}>
                <div className="galleryimg homegallery">
                    <div className="galleryimgbox">
                      <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${img}`} className="img-fluid"  alt="MMATD"
                    /></LazyLoad>
                    <div className="gallerydesc">
                      <Link to="/" className="gallery_button"> {day} {month}</Link>
                      <h6> {item.title}</h6>
                    </div>
                  </div> 
              </div>
           </div>
              )})
              )}   

              <div className="item">
                <div className="galleryimg homegallery">
                    <div className="galleryimgbox">
                      <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/gallery1.jpg" className="img-fluid"  alt="MMATD"
                    /></LazyLoad>
                    <div className="gallerydesc">
                      <Link to="/" className="gallery_button">DD MM</Link>
                      <h6> Gallery Title</h6>
                    </div>
                  </div> 
              </div>
         </div>
         <div className="item">
              <div className="galleryimg homegallery">
                  <div className="galleryimgbox">
                    <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/gallery2.jpg" className="img-fluid"  alt="MMATD"
                  /></LazyLoad>
                  <div className="gallerydesc">
                    <Link to="/" className="gallery_button">DD MM</Link>
                    <h6> Gallery Title</h6>
                  </div>
                </div> 
            </div>
        </div>
        <div className="item">
        <div className="galleryimg homegallery">
            <div className="galleryimgbox">
              <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/gallery1.jpg" className="img-fluid"  alt="MMATD"
            /></LazyLoad>
            <div className="gallerydesc">
                      <Link to="/" className="gallery_button">DD MM</Link>
                      <h6> Gallery Title</h6>
                    </div>
                  </div> 
              </div>
        </div>
        </Slider>
      
    </>
  );
};

export default Gallery;
